/* tslint:disable */
/* eslint-disable */
/**
 * fantasy-dynasty-app
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Status for a contract
 * @export
 * @enum {string}
 */

export const ContractStatus = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Waived: 'WAIVED',
    Terminated: 'TERMINATED',
    Expired: 'EXPIRED',
    Complete: 'COMPLETE'
} as const;

export type ContractStatus = typeof ContractStatus[keyof typeof ContractStatus];



